import React, {Component} from 'react';
import {connect} from 'react-redux';
import MultiSelect from 'components/atoms/dropdowns/multi-select';

function getPlayerOptions(players) {
    return Object.values(players).map((player) => {
        return {
            value: player.getId(),
            label: player.name,
        };
    });
}

class SelectPlayers extends Component {
    constructor(props) {
        super(props);

        this.state = {playerIds: []};
    }

    onSelect(selectedValues) {
        const playerIds = selectedValues.map((value) => String(value));

        this.props.onSelect(playerIds);

        this.setState({playerIds});
    }

    render() {
        const {players} = this.props;

        if (!players.hasPlayers()) {
            return false;
        }

        return (
            <MultiSelect
                onSelect={::this.onSelect}
                options={getPlayerOptions(players.all())}
                placeholder={'Select player'}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {playersData} = state;

    return {
        players: playersData.players,
    };
}

export default connect(mapStatesToProps)(SelectPlayers);
